import * as React from "react";
import type { SVGProps } from "react";
const SvgApplicationSubmittedIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={19}
    height={20}
    fill="currentColor"
    viewBox="0 0 19 20"
    {...props}
  >
    <path
      fill="currentColor"
      d="m12.4 15.65 4.903-4.903a.81.81 0 0 1 .622-.26.9.9 0 0 1 .625.288.875.875 0 0 1 .007 1.268L13.05 17.55a.876.876 0 0 1-1.275 0L8.8 14.575a.86.86 0 0 1-.275-.625q0-.35.275-.625a.875.875 0 0 1 1.275 0zM2.393 19.4q-.743 0-1.268-.529A1.74 1.74 0 0 1 .6 17.6V4.4q0-.743.529-1.271A1.73 1.73 0 0 1 2.4 2.6h4.275q.2-.775.837-1.288Q8.15.8 9 .8q.85 0 1.488.512.637.513.837 1.288H15.6q.743 0 1.271.529.53.528.529 1.271v3.3a.87.87 0 0 1-.257.641.86.86 0 0 1-.638.259.88.88 0 0 1-.642-.259.86.86 0 0 1-.263-.641V4.4h-1.8v2.1a.87.87 0 0 1-.259.641.87.87 0 0 1-.641.259H5.1a.87.87 0 0 1-.641-.259A.87.87 0 0 1 4.2 6.5V4.4H2.4v13.2h4.493q.383 0 .644.257a.86.86 0 0 1 .263.638.88.88 0 0 1-.259.642.87.87 0 0 1-.642.263zm6.602-15a.88.88 0 0 0 .642-.257.86.86 0 0 0 .263-.638.88.88 0 0 0-.257-.643.86.86 0 0 0-.638-.262.88.88 0 0 0-.643.257.86.86 0 0 0-.262.638q0 .38.257.642a.86.86 0 0 0 .638.263"
    />
  </svg>
);
export default SvgApplicationSubmittedIcon;
